/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from 'zod/v4'

export const putUsersPreferencesUnitsStatus200Schema = z.object({
  id: z.string().describe('Unique identifier').meta({ examples: [1] }),
  type: z.enum(['area', 'density', 'diameter', 'differentialPressure', 'electricalPower', 'energy', 'flow', 'force', 'heatTransfer', 'kinematicViscosity', 'kvCvCoefficient', 'length', 'linearPressureDrop', 'mass', 'roughness', 'specificHeat', 'staticPressure', 'temperature', 'temperatureDifference', 'thermalConductivity', 'thermalPower', 'thickness', 'torque', 'velocity', 'volume', 'waterHardness']).describe('The type of the unit').meta({ examples: ['length'] }),
  value: z.string().describe('The preferred unit of the user for the given type').meta({ examples: ['_U_LENGTH_CM'] }),
})

export const putUsersPreferencesUnitsStatus400Schema = z.string()

export const putUsersPreferencesUnitsStatus401Schema = z.string()

export const putUsersPreferencesUnitsStatus500Schema = z.string()

export const putUsersPreferencesUnitsResponseSchema = putUsersPreferencesUnitsStatus200Schema

export const putUsersPreferencesUnitsErrorSchema = z.union([putUsersPreferencesUnitsStatus400Schema, putUsersPreferencesUnitsStatus401Schema, putUsersPreferencesUnitsStatus500Schema])

export const putUsersPreferencesUnitsBodySchema = z.array(z.object({
  type: z.enum(['area', 'density', 'diameter', 'differentialPressure', 'electricalPower', 'energy', 'flow', 'force', 'heatTransfer', 'kinematicViscosity', 'kvCvCoefficient', 'length', 'linearPressureDrop', 'mass', 'roughness', 'specificHeat', 'staticPressure', 'temperature', 'temperatureDifference', 'thermalConductivity', 'thermalPower', 'thickness', 'torque', 'velocity', 'volume', 'waterHardness']).describe('The type of the unit').meta({ examples: ['length'] }),
  value: z.string().describe('The preferred unit of the user for the given type').meta({ examples: ['_U_LENGTH_CM'] }),
})).optional()
